module.exports = __webpack_public_path__ + "img/icon-map.f1a79d81.png";